/**
 *
 * UnsafeHtml
 *
 */

/* eslint react/no-danger: off */
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import classnames from 'classnames';

var UnsafeHtml = function UnsafeHtml(_ref) {
  var children = _ref.children,
      wrapper = _ref.wrapper,
      extraClasses = _ref.extraClasses;
  var Wrapper = wrapper && wrapper.toLowerCase() !== 'script' ? wrapper : 'div';

  var createMarkup = function createMarkup(elem) {
    var content = elem;

    if (typeof elem !== 'string') {
      content = elem instanceof Array && elem.map(function (v) {
        return typeof v === 'string' ? v : ReactDOMServer.renderToStaticMarkup(v);
      }).join('') || ReactDOMServer.renderToStaticMarkup(elem);
    }

    return {
      __html: String(content).replace(/<script>(.+)<\/script>/gi, '')
    };
  };

  return React.createElement(Wrapper, {
    className: classnames(extraClasses),
    dangerouslySetInnerHTML: createMarkup(children)
  });
};

UnsafeHtml.displayName = 'UnsafeHtml';
UnsafeHtml.defaultProps = {
  extraClass: '',
  wrapper: 'div'
};
export default UnsafeHtml;